import { Text } from "theme-ui";
import { Alert, DisplayComponentVariants } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  Text,
  Alert,
  DisplayComponentVariants,
  React
};